// extracted by mini-css-extract-plugin
export var currencyInput = "_nf-1";
export var currencySymbol = "_nf-0";